import React from 'react';
import styled from 'styled-components';


const CustomTitleBlock = styled.h2`
    margin-bottom: ${props => props.marginBottom || '40px'};
    margin-top: ${props => props.marginTop || '0px'};
    font-size: ${props => props.fontSize || '32px'};
    font-weight: ${props => props.fontWeight || '500'};
    text-align: ${props => props.textAlign || 'center'};
    color: ${props => props.textColor || '#fff'};
    padding: ${props => props.padding || '0px'};
    //height: ${props => props.fontSize || 'fontSize'};
    display : ${props => props.display || 'block'};
    height : ${props => props.height || 'fontSize'};
    line-height: ${props => props.lineHeight || '1'};;
`;

const CustomTitle = ({ title, textColor, fontSize,
    fontWeight, textAlign, marginBottom, marginTop,
    padding, display , height, lineHeight}) => {
    return (
        <CustomTitleBlock fontSize={fontSize}
            fontWeight={fontWeight} textAlign={textAlign}
            marginBottom={marginBottom}
            marginTop={marginTop}
            textColor={textColor}
            padding={padding}
            display = {display === undefined || display === null ? "block":display}
            height = {height}
            lineHeight = {lineHeight} >
            {title && typeof(title) === "string" && title.length > 0 ? title.split("\n").map(function(item, idx) {
           return (
               <span key={idx}>
                   {item}
                   <br/>
               </span>
            )
       }) : title}
        </CustomTitleBlock>
    );
};

export default CustomTitle;